export const VENUE_FEATURE_NAME_SINGULAR = 'Venue Exclusive'
export const VENUE_FEATURE_NAME = `${VENUE_FEATURE_NAME_SINGULAR}s`

export const BENEFITS_EXPLAINER_TITLE = `Unlock ${VENUE_FEATURE_NAME_SINGULAR} Offers`
export const BENEFITS_EXPLAINER_TEXT = `Gain access to exclusive benefits when visiting a TAB agency, Pub, or Racecourse.`

export const LOCATION_DISABLED_TITLE = 'Location Access Disabled'
export const LOCATION_DISABLED_TEXT = `To access ${VENUE_FEATURE_NAME_SINGULAR} offers, please enable location services.`
